export default __webpack_public_path__ + "static/iot_3-823248a389e2f8f3006bef703260bbb1.jpg";